import { render, staticRenderFns } from "./carpCategoryListComponent.vue?vue&type=template&id=45720c9b&"
import script from "./carpCategoryListComponent.vue?vue&type=script&lang=ts&"
export * from "./carpCategoryListComponent.vue?vue&type=script&lang=ts&"
import style0 from "./carpCategoryListComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports